import React, { memo } from 'react';
import Question from './question';
import { FaqContainer, List, ListHeader } from './components';
import { Text } from '@spotify-internal/encore-web/core';

type FaqPropTypes = {
  header?: { text: string; textAlign?: string };
  container?: React.ComponentProps<typeof FaqContainer>;
  data?: {
    header: string;
    content: string;
  }[];
};

export function Faq(props: FaqPropTypes) {
  const { data, container, header } = props;

  return (
    <FaqContainer {...container}>
      {header && (
        <ListHeader textAlign="center">
          <Text as="h2" variant="titleLarge">
            {header.text}
          </Text>
        </ListHeader>
      )}
      <List>
        {data &&
          data.map((question, i) => (
            <Question key={`question-${i}`} {...question} />
          ))}
      </List>
    </FaqContainer>
  );
}

export default memo(Faq);
